/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import useFechas from "../../hooks/useFechas";
// import ModalAdd from "./Modals/ModalAdd";
import DataTable from "../../components/DataTable/DataTable";
import { formatCurrency } from "../../utils/formato";
import Link from "../../components/Form/Link";
import Title from "../../components/Form/Title";
import { hideLoader, showLoader, setTitle } from "../../reducers/loaderReducer";
import { useDispatch } from "react-redux";
import useLogin from "../../hooks/useLogin";
import Swal from "sweetalert2";

const Estado = ({ status }) => {
  if (status === "Pagado") {
    return (
      <div className="badge badge-outline-success text-success">Pagado</div>
    );
  }

  if (status === "Pendiente") {
    return (
      <div className="badge badge-outline-warning text-warning">Pendiente</div>
    );
  }

  return null;
};

const construirColumnas = (generatePDF) => [
  { field: "proyecto", title: "Proyecto" },
  { field: "cuenta_padre", title: "Cuenta Padre" },
  { field: "cuenta_presupuental", title: "Cuenta Presupuestal" },
  { field: "fecha", title: "Fechas de pagos" },
  {
    field: "monto",
    title: "Monto",
    align: "center",
    sortValue: (fila) => Number(fila.monto) || 0,
    render: (fila) => formatCurrency(fila.monto),
  },
  {
    field: "status",
    title: "Status",
    filterable: false,
    align: "center",
    render: (fila) => <Estado status={fila.status} />,
  },
  {
    field: "orden_pdf",
    title: "Orden PDF",
    sortable: false,
    filterable: false,
    align: "center",
    render: (fila) =>
      fila.folio != null && (
        <button className="btn btn-danger btn-sm" onClick={() => generatePDF(fila)}>
          PDF
        </button>
      ),
  },
];

/** La dirección del cliente viene en campos separados. */
const direccionDe = (fila) =>
  [
    fila.calle,
    fila.exterior,
    fila.inerior,
    fila.colonia,
    fila.cp,
    fila.nom_mun,
    fila.nom_estado,
    fila.nom_pais,
  ].join(" ");

const date = new Date();

const getWeek = (fecha) => {
  const onejan = new Date(fecha.getFullYear(), 0, 1);
  return Math.ceil(((fecha - onejan) / 86400000 + onejan.getDay() + 1) / 7);
};

const getMonthName = (mes) =>
  [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
  ][mes - 1] ?? "Mes no encontrado";

const getFirstDayOfWeek = (fecha) => {
  const dia = fecha.getDay();
  const diff = fecha.getDate() - dia + (dia === 0 ? -6 : 1);
  const primerDia = new Date(fecha.setDate(diff));
  return primerDia.getDate() + " de " + getMonthName(primerDia.getMonth() + 1);
};

const getLastDayOfWeek = (fecha) => {
  const dia = fecha.getDay();
  const diff = fecha.getDate() - dia + (dia === 0 ? -6 : 1) + 6;
  const ultimoDia = new Date(fecha.setDate(diff));
  return ultimoDia.getDate() + " de " + getMonthName(ultimoDia.getMonth() + 1);
};

export default function Index() {
  const { user_id, logout, token, proveedor_id, user_rol } = useLogin();
  const dispatch = useDispatch();
  const { loading, error, message, success, Fecha, FechasGetService } =
    useFechas();
  const [modal, setModal] = useState(false);
  const [Update, setUpdate] = useState(false);
  const [Id, setId] = useState("");
  const [Nombre, setNombre] = useState("");
  const [Numeracion, setNumeracion] = useState("");
  let i = 1;

  const toggle = () => {
    setModal(!modal);
    setUpdate(false);
    setId("");
    setNombre("");
    setNumeracion("");
  };

  useEffect(() => {
    dispatch(setTitle("Descargando Fechas de pago"));
    dispatch(showLoader());
    FechasGetService(proveedor_id, token);
    return () => {};
  }, []);

  useEffect(() => {
    if (Fecha.length >= 0) {
      dispatch(hideLoader());
      dispatch(setTitle(""));
    }
    return () => {};
  }, [Fecha]);

  useEffect(() => {
    if (success === true) {
      FechasGetService(proveedor_id, token);
    }
  }, [FechasGetService, success]);

  const formatNumber = (number) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, success]);

  // jspdf y su autotable pesan ~1.4 MB de fuente. Se cargan al generar el
  // PDF para que no viajen en el bundle inicial.
  //
  // Antes esto era fijo para cualquier fila: siempre mostraba la misma
  // empresa/RFC/banco de alguien más ("ELYSIAN SYS", ni siquiera la del
  // encabezado que mostraba a su vez OTRA empresa distinta), sin importar
  // a qué proveedor le correspondía ver esta orden. También tenía 5 llamadas
  // a autoTable(doc, {html:"#..."}) que no hacían nada (esos elementos nunca
  // existieron en la página).
  const generatePDF = async (fila) => {
    const { default: jsPDF } = await import("jspdf");
    const { default: autoTable } = await import("jspdf-autotable");

    const doc = new jsPDF();
    let subtotal = 0;

    const direecion = direccionDe(fila);
    const ordenes_pagos = JSON.parse(fila.ordenes_pagos);

    const nombreProveedor =
      [fila.proveedor_nombre, fila.proveedor_apellido_p, fila.proveedor_apellido_m]
        .filter(Boolean)
        .join(" ") || "Proveedor sin nombre registrado";
    const rfcProveedor = fila.proveedor_rfc || "Sin RFC registrado";
    const bancoProveedor = fila.proveedor_banco || "Sin banco registrado";
    const clabeProveedor = fila.proveedor_clabe || "Sin CLABE registrada";
    const productor = fila.productor || "—";
    const director = fila.director_de_produccion || "—";
    const ejecutivo = fila.productor_ejecutivo || "—";

    var img = new Image();
    img.src = "/logo-login.jpg";
    //img.src = "/incidencias/images/Logo_Horizontal_ANAM.png";
    doc.addImage(img, "png", 10, 10, 80, 20);
    doc.setFontSize(12);
    doc.text(110, 10, fila.nombre_comercial);
    doc.setFontSize(10);
    doc.text(110, 15, "RFC: " + fila.RFC);
    doc.text(110, 20, direecion, { align: "left", lineHeightFactor: 1, maxWidth: 100 });
    doc.text(110, 29, fila.proyecto);
    doc.text(110, 33, "(" + fila.empresa + ")");
    doc.text(110, 38, "SOLICITUD DE PAGO No. " + (fila.folio ?? ""));
    doc.text(110, 43, "FECHA DE ELABORACION: " + fila.created_at);

    autoTable(doc, {
      theme: "grid",
      body: [
        [
          "PERIODO DE PAGO",
          "Del " +
            getFirstDayOfWeek(date) +
            " al " +
            getLastDayOfWeek(date) +
            " del " +
            date.getFullYear(),
          "SEMANA",
          getWeek(date) - 1,
        ],
        [
          { content: "FECHA DE PAGO", colSpan: 1 },
          { content: fila.fecha_pago, colSpan: 1 },
          { content: "FORMA DE PAGO", colSpan: 1 },
          { content: "03 - Transferencia electrónica de fondos", colSpan: 3 },
        ],
      ],

      startY: 50,
    });

    autoTable(doc, {
      theme: "plain",
      body: [
        ["PROVEEDOR DEL SERVICIO", nombreProveedor],
        ["PAGO A FAVOR DE:", nombreProveedor],
        ["R. F. C.", rfcProveedor],
        ["BANCO", bancoProveedor],
        ["CUENTA - CLABE", clabeProveedor],
      ],

      startY: 73,
    });

    autoTable(doc, {
      theme: "striped",
      head: [["CANTIDAD", "DESCRIPCIÓN", "PARTIDA P", "IMPORTE"]],
      body: ordenes_pagos.map((product) => {
        subtotal += product.monto;
        return [
          1,
          product.nombre,
          { content: product.cuenta_presupuental, styles: { halign: "center" } },
          { content: "$" + formatNumber(product.monto), styles: { halign: "right" } },
        ];
      }),
      foot: [
        [
          "",
          "",
          "SUBTOTAL",
          { content: "$" + formatNumber(subtotal), styles: { halign: "right" } },
        ],
        [
          "",
          "",
          "IVA",
          { content: "$" + formatNumber(subtotal * 0.16), styles: { halign: "right" } },
        ],
        [
          "",
          "",
          "TOTAL A PAGAR",
          { content: "$" + formatNumber(subtotal * 1.16), styles: { halign: "right" } },
        ],
      ],

      startY: 115,
    });

    autoTable(doc, {
      theme: "grid",
      body: [
        ["PRODUCTOR", "DIRECCIÓN DE PRODUCCIÓN", "PRODUCTOR EJECUTIVO"],
        [productor, director, ejecutivo],
      ],
    });

    autoTable(doc, {
      theme: "plain",
      body: [
        [
          "Nota",
          "El pago se hará a la cuenta bancaria indicada en esta solicitud de pago, por lo que se solicita a la empresa proveedora de servicios, que en caso de no ser la misma cuenta bancaria, se indique la cuenta a la que se hará el depósito.",
        ],
      ],
    });

    // doc.text(
    //   15,
    //   200,
    //   "Nota: ",
    //   { align: "left", lineHeightFactor: 1, maxWidth: 180 }
    // );

    // doc.save("demo.pdf");
    window.open(
      doc.output("bloburl"),
      "_blank",
      "toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,modal=yes,top=100,left=250,width=1200,height=800"
    );
  };

  const columnas = construirColumnas(generatePDF);

  return (
    <>
      {/* <ModalAdd
        modal={modal}
        toggle={toggle}
        Nombre={Nombre}
        Numeracion={Numeracion}
        Update={Update}
        Id={Id}
        token={token}
        setNombre={setNombre}
        setNumeracion={setNumeracion}
        FechasGetService={FechasGetService}
        proveedor_id={proveedor_id}
      /> */}
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <Title title="Listado de Fechas de pago" className="text-left" />
          </div>
          {/* <div className="col-md-6 text-end">
            <a className="btn btn-info" onClick={toggle}>
              Agregar variable
            </a>
          </div> */}
        </div>
        <br />
        <div className="row">
          <div className="col-md-12">
            <div className="crud-card">
              <DataTable tableKey="fechas-pago" loading={loading} columns={columnas} data={Fecha} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
